import React from 'react';
export function BrandHeader() {
  return <div className="flex items-center py-6 px-6 md:px-8 w-full max-w-5xl mx-auto" data-id="element-33">
      <img src="https://cdn.magicpatterns.com/uploads/wppiUNK9xdr2ZYqDwBD61S/medmasterslogo.png" alt="MedMasters" className="h-8 md:h-9 w-auto" data-id="element-34" />
    </div>;
}